document.addEventListener('DOMContentLoaded', function() {
  function isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  var hc_links = document.querySelectorAll('.hc-grid-link');
  hc_links.forEach(function(hc_link) {
    hc_link.addEventListener('click', function(e) {
      if (isMobileDevice()) {
        e.preventDefault();
      }
    });
  });
});